import React, { useEffect } from 'react';
import { useAuthStore } from './store/authStore';
import { useThemeStore } from './store/themeStore';
import { LoginScreen } from './pages/LoginScreen';
import { Workspace } from './pages/Workspace';

export default function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { theme } = useThemeStore();
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);
  return isAuthenticated ? <Workspace /> : <LoginScreen />;
}
